<div class="margin-top-xl">
    <div class="container">
        @if(isMaintenance){
        <app-maintenance-banner></app-maintenance-banner>
        }
        @if(isLoading){
        <mat-spinner class="margin-left-half"></mat-spinner>
        }
        <div class="quicksight-container" id="quicksight-dashboard-commissions"></div>
        @if(isError){
        <h1 i18n>Something went wrong. Please refresh page to try again.</h1>
        }
    </div>
</div>